export default "__VITE_ASSET__CeXjpnb2__"